import React from 'react';
import cn from 'classnames';
import { Tooltip } from 'antd';
import PhoneRecords from '../../PhoneRecords/PhoneRecords';
import { ReactComponent as ClipIcon } from '../../../resource/ClipIcon.svg';
import { ReactComponent as ChargeableIcon } from '../../../resource/ChargeableIcon.svg'; // платная
import { ReactComponent as DangerSignIcon } from '../../../resource/DangerSignIcon.svg'; // аварийная
import { ReactComponent as PossWarrantyIcon } from '../../../resource/QuestionSignIcon.svg'; // возможно гарантия
import { ReactComponent as RetryIcon } from '../../../resource/RetryTwoArrowsIcon.svg'; // повторная
import { ReactComponent as NotWarrantyIcon } from '../../../resource/NotWarrantyIcon.svg'; // из приложения
import { ToolIcon, GarantyIcon as WarrantyIcon } from '../../../resource/icons';
import { CreationMethod } from '../../../components/requestComponents/index';
import useRequestCreationMethods from '../../../queries/useRequestCreationMethods';
import styles from './RequestMarks.module.scss';

const RequestMarks = ({
  request = {},
  iconClassName,
  getPopupContainer = () => document.body,
  rootClassName,
  rowExpanded = false,
  onBindCallToRequestSucces,
  onCreationMethodChange,
  isStatistics,
  ...props
}) => {
  const { data } = useRequestCreationMethods({ staleTime: Infinity });

  const icons = [
    <PhoneRecords
      key="PhoneRecords"
      requestId={request.id}
      hasRecord={request.hasRecord}
      newDesign
      getPopupContainer={getPopupContainer}
      className={iconClassName}
      onBindCallSuccess={onBindCallToRequestSucces}
      {...props}
    />,
    request.hasAttachment && (
      <Tooltip mouseLeaveDelay={0} title="Вложения" key="ClipIcon">
        <ClipIcon className={iconClassName} {...props} />
      </Tooltip>
    ),
    request.isImmediate && (
      <Tooltip mouseLeaveDelay={0} title="Аварийная" key="DangerSignIcon">
        <DangerSignIcon className={iconClassName} {...props} />
      </Tooltip>
    ),
    request.isChargeable && (
      <Tooltip mouseLeaveDelay={0} title="Платная" key="ChargeableIcon">
        <ChargeableIcon className={iconClassName} {...props} />
      </Tooltip>
    ),
    request.isInternal && (
      <Tooltip mouseLeaveDelay={0} title="Внутренняя" key="ToolIcon">
        <ToolIcon className={iconClassName} {...props} />
      </Tooltip>
    ),
    request.garantyId === 2 && (
      <Tooltip
        mouseLeaveDelay={0}
        title="Возможно гарантийная"
        key="PossWarrantyIcon"
      >
        <PossWarrantyIcon className={iconClassName} {...props} />
      </Tooltip>
    ),
    request.garantyId === 1 && (
      <Tooltip mouseLeaveDelay={0} title="Гарантийная" key="WarrantyIcon">
        <WarrantyIcon className={iconClassName} {...props} />
      </Tooltip>
    ),
    request.garantyId === 0 && (
      <Tooltip mouseLeaveDelay={0} title="Не гарантийная" key="NotWarrantyIcon">
        <NotWarrantyIcon className={iconClassName} {...props} />
      </Tooltip>
    ),
    request.isRetry && (
      <Tooltip mouseLeaveDelay={0} title="Повторная" key="RetryIcon">
        <RetryIcon className={iconClassName} {...props} />
      </Tooltip>
    ),
    request.creationMethod && (
      <CreationMethod
        record={request}
        methods={data}
        onOk={
          typeof onCreationMethodChange === 'function'
            ? ({ requestId, method }) =>
                onCreationMethodChange(requestId, method)
            : undefined
        }
        iconStyle={{
          position: 'relative',
          left: '0',
          top: '-3px',
          height: '24px',
        }}
        spanStyle={{ marginLeft: '10px' }}
        key="CreationMethodIcon"
        isStatistics={isStatistics}
        {...props}
      />
    ),
  ].filter(Boolean);

  if (icons.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(styles.root, rootClassName, {
        [styles.rowExpanded]: rowExpanded,
      })}
    >
      {icons}
    </div>
  );
};

export default RequestMarks;
